import { render, staticRenderFns } from "./AccountCreated.vue?vue&type=template&id=5614bd22&scoped=true&"
import script from "./AccountCreated.vue?vue&type=script&lang=js&"
export * from "./AccountCreated.vue?vue&type=script&lang=js&"
import style0 from "./AccountCreated.vue?vue&type=style&index=0&id=5614bd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5614bd22",
  null
  
)

export default component.exports